import React from 'react'

const UserIcon20pxSvg = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 9.99935C12.3012 9.99935 14.1667 8.13387 14.1667 5.83268C14.1667 3.5315 12.3012 1.66602 10 1.66602C7.69882 1.66602 5.83334 3.5315 5.83334 5.83268C5.83334 8.13387 7.69882 9.99935 10 9.99935Z" fill="#6B7280" />
            <path d="M9.99999 12.084C5.82499 12.084 2.42499 14.884 2.42499 18.334C2.42499 18.5673 2.60832 18.7507 2.84165 18.7507H17.1583C17.3917 18.7507 17.575 18.5673 17.575 18.334C17.575 14.884 14.175 12.084 9.99999 12.084Z" fill="#6B7280" />
        </svg>
    )
}

export default UserIcon20pxSvg